/** Maps legacy English `Header` strings to `admin.table.columns.*` keys. */
export const TABLE_COLUMN_HEADER_I18N_KEYS: Record<string, string> = {
  Name: 'name',
  'First Name': 'firstName',
  'Last Name': 'lastName',
  Email: 'email',
  Phone: 'phone',
  'Mobile Phone': 'mobilePhone',
  Mobile: 'mobile',
  'Home Phone': 'homePhone',
  Home: 'home',
  Permission: 'permission',
  'Last Login': 'lastLogin',
  'Joined Date': 'joinedDate',
  'Person Id': 'personId',
  Id: 'id',
  ID: 'id',
  Role: 'role',
  Status: 'status',
  Actions: 'actions',
  Groups: 'groups',
  Tags: 'tags',
  Hours: 'hours',
  Donations: 'donations',
  Contact: 'contact',
  Address: 'address',
  'Date of Birth': 'dateOfBirth',
  'Member Since': 'memberSince',
  'Invited On': 'invitedOn',
  'Latest Activity': 'latestActivity',
  Event: 'event',
  'Event Name': 'eventName',
  'Event Date': 'eventDate',
  'Event Time': 'eventTime',
  Opportunity: 'opportunity',
  'Opportunity Name': 'opportunityName',
  Title: 'title',
  Type: 'type',
  Date: 'date',
  Start: 'start',
  End: 'end',
  Created: 'created',
  Country: 'country',
  Members: 'members',
  Volunteers: 'volunteers',
  Activities: 'activities',
  Website: 'website',
  Order: 'order',
  'Check-In Time': 'checkInTime',
  'Check-Out': 'checkOut',
  'Check-In': 'checkIn',
  Reflections: 'reflections',
  Notes: 'notes',
  Location: 'location',
  Visibility: 'visibility',
  Registrations: 'registrations',
  Day: 'day',
}
